export const containerStyles = {
	margin: '3rem auto',
};
